import { init as initApi, save as saveApi } from "../../service/WebEvaluation2Service";

export const INIT_SUCCESS = "WEB_EVALUATION2_INIT_SUCCESS";
export const INIT_FAIL = "WEB_EVALUATION2_INIT_FAIL";
export const EVALUATION_SAVE_SUCCESS = "WEB_EVALUATION2_EVALUATION_SAVE_SUCCESS";
export const EVALUATION_SAVE_FAIL = "WEB_EVALUATION2_EVALUATION_SAVE_FAIL";

export const init = params => dispatch => {
  initApi(params)
    .then(response => {
      dispatch({
        type: INIT_SUCCESS,
        payload: {
          grade: response.student.grade,
          classNumber: response.student.classNumber,
          number: response.student.number,
          name: response.student.name,
          title: response.subTitle,
          item: response.evaluationItem,
          gradeRange: response.gradeRange
        }
      });
    })
    .catch(error => {
      dispatch({ type: INIT_FAIL, payload: { error: error } });
    });
};

export const save = params => dispatch => {
  saveApi(params)
    .then(response => {
      dispatch({ type: EVALUATION_SAVE_SUCCESS });
      const popUp = `下記の評価内容を登録しました。\r\n
    対象生徒：${response.studentDto.grade}-${response.studentDto.classNumber}-${response.studentDto.number} ${response
        .studentDto.name} \r\n 
    評価内容：${response.title}\r\n
    評価期間：${response.termName}\r\n`;

      alert(popUp);

      window.location.href = "/EvaluationImplement";
    })
    .catch(error => {
      dispatch({ type: EVALUATION_SAVE_FAIL, payload: { error: error } });
    });
};
